var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "VanLoading" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "FromWarehouseId",
                        error: _vm.$v.form.FromWarehouseId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.FromWarehouseId,
                          url:
                            "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                          "dynamic-and-condition": {
                            StatusIds: [1],
                            IsVehicle: 0
                          }
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "FromWarehouseId",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RouteId",
                        error: _vm.$v.form.RouteId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.RouteId,
                          url: "VisionNextRoute/api/Route/AutoCompleteSearch",
                          "dynamic-and-condition": { StatusIds: [1] },
                          "order-by-columns": [
                            { Column: "Description1", OrderByType: 0 }
                          ],
                          "page-count": 500
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("RouteId", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "LoadingDate",
                        error: _vm.$v.form.LoadingDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.LoadingDate },
                        model: {
                          value: _vm.form.LoadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoadingDate", $$v)
                          },
                          expression: "form.LoadingDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: { "item-key": "IsDone", error: _vm.$v.form.IsDone }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { disabled: _vm.insertReadonly.IsDone },
                        model: {
                          value: _vm.form.IsDone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "IsDone", $$v)
                          },
                          expression: "form.IsDone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Canceled",
                        error: _vm.$v.form.Canceled,
                        md: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          disabled: _vm.insertReadonly.Canceled,
                          type: "number",
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.Canceled,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Canceled", $$v)
                          },
                          expression: "form.Canceled"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.vanLoading.items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.items"),
                            error: _vm.$v.vanLoadingItem.Item
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "custom-option": true,
                              "or-condition-fields": "Code,Description1",
                              disabled:
                                !_vm.form.FromWarehouseId ||
                                !_vm.form.RouteId ||
                                !_vm.form.LoadingDate,
                              url: "VisionNextItem/api/Item/AutoCompleteSearch",
                              label: "Description1",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8]
                              },
                              searchable: ""
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.vanLoadingItem.Item,
                              callback: function($$v) {
                                _vm.$set(_vm.vanLoadingItem, "Item", $$v)
                              },
                              expression: "vanLoadingItem.Item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.FromWhStockQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.FromWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "FromWhStockQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.FromWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.ToWhStockQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.ToWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "ToWhStockQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.ToWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.AverageSalesQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.AverageSalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "AverageSalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.AverageSalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.LastSalesQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.LastSalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "LastSalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.LastSalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.LastdaySalesQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.LastdaySalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "LastdaySalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.LastdaySalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.SuggestedQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.SuggestedQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "SuggestedQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.SuggestedQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.LoadingQuantity"),
                            required: true,
                            error: _vm.$v.vanLoadingItem.LoadingQuantity
                          }
                        },
                        [
                          this.vanLoadingItem.UnitId === 1526
                            ? _c("NextInput", {
                                attrs: { type: "text" },
                                on: {
                                  keypress: function($event) {
                                    _vm.onlyForNumber($event)
                                    _vm.keypress($event)
                                  }
                                },
                                model: {
                                  value: _vm.vanLoadingItem.LoadingQuantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.vanLoadingItem,
                                      "LoadingQuantity",
                                      $$v
                                    )
                                  },
                                  expression: "vanLoadingItem.LoadingQuantity"
                                }
                              })
                            : _c("NextInput", {
                                attrs: { type: "text" },
                                on: {
                                  keypress: function($event) {
                                    _vm.onlyForCurrencyDotOrComma($event)
                                    _vm.keypress($event)
                                  }
                                },
                                model: {
                                  value: _vm.vanLoadingItem.LoadingQuantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.vanLoadingItem,
                                      "LoadingQuantity",
                                      $$v
                                    )
                                  },
                                  expression: "vanLoadingItem.LoadingQuantity"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right ml-auto addButton",
                          attrs: { cols: "12", md: "3" }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("insert.vanLoading.items"),
                                "label-class": "v-none"
                              }
                            },
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItem()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c("NextMultipleSelection", {
                            attrs: {
                              name: "VanLoadingMultipleItem",
                              "disabled-button":
                                !_vm.form.FromWarehouseId ||
                                !_vm.form.RouteId ||
                                !_vm.form.LoadingDate,
                              "dynamic-and-condition": {
                                WarehouseIds: [_vm.form.FromWarehouseId],
                                RouteIds: [_vm.form.RouteId],
                                DocumentDate: _vm.form.LoadingDate
                              },
                              "hidden-values": _vm.hiddenValues,
                              "clickable-columns": _vm.clickableColumns,
                              validations: _vm.loadingQuantityValidation
                            },
                            model: {
                              value: _vm.VanLoadingItems,
                              callback: function($$v) {
                                _vm.VanLoadingItems = $$v
                              },
                              expression: "VanLoadingItems"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.vanLoading.items")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.FromWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.ToWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.AverageSalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LastSalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LastdaySalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.SuggestedQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LoadingQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.VanLoadingItems, function(r, i) {
                                  return _c(
                                    "b-tr",
                                    { key: i },
                                    [
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.Description1))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.FromWhStockQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.ToWhStockQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.AverageSalesQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.LastSalesQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.LastdaySalesQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.SuggestedQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatValue(r.LoadingQuantity)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-td",
                                        { staticClass: "text-center" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-edit text-warning",
                                            on: {
                                              click: function($event) {
                                                return _vm.editVanLoadingItems(
                                                  r
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "far fa-trash-alt text-danger",
                                            on: {
                                              click: function($event) {
                                                return _vm.removeVanLoadingItems(
                                                  r
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ba2690a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ba2690a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VanLoading/insert.vue
// module id = null
// module chunks = 